import { Text } from '@src/components';
const DraftOrder = () => {
  return (
    <div data-testid="draft-order">
      <h1>
        <Text t="draftOrder" />
      </h1>
    </div>
  );
};

export default DraftOrder;
